export default "__VITE_ASSET__wnP7XNR6__"